import { motion } from 'framer-motion'

const variants = {
	open: {
		opacity: 1,
		visibility: 'visible',
		x: 0,
	},
	closed: {
		opacity: 0,
		visibility: 'hidden',
		x: -20,
	},
}

function PortfolioModal(props) {
	return (
		<motion.div
			variants={variants}
			initial='closed'
			animate={props.isOpen ? 'open' : 'closed'}
			transition={{ duration: 0.3 }}
			className='fixed z-50 top-0 left-0 w-full h-full flex justify-center items-center'
		>
			<div
				onClick={() => props.clickOutside(false)}
				className='w-full h-full bg-[#FAFAFA] dark:bg-dark-400 opacity-60 absolute top-0'
			/>
			<div className='w-full sm:w-[600px] p-[20px] mx-[20px] bg-white shadow-2xl dark:bg-dark-300 z-50'>
				<p className='text-[24px] font-medium text-black dark:text-white'>
					{props.title}
				</p>
				<img
					src={props.image}
					alt='portfolio'
					className='w-full mt-[15px]'
				/>
			</div>
		</motion.div>
	)
}

export default PortfolioModal
